import { api } from './api';
import { debugEnabled, dlog } from '../utils/debug';

export class StripeService {
  async createCheckoutSession(token: string): Promise<string> {
    try {
      const response = await api.createCheckoutSession(token);
      return response.checkout_url;
    } catch (error) {
      console.error('Failed to create checkout session:', error);
      throw error;
    }
  }

  async createCustomerPortalSession(token: string): Promise<string> {
    try {
      const response = await api.createCustomerPortalSession(token);
      return response.portal_url;
    } catch (error) {
      console.error('Failed to create customer portal session:', error);
      throw error;
    }
  }

  async redirectToCheckout(token: string): Promise<void> {
    try {
      const checkoutUrl = await this.createCheckoutSession(token);
      window.location.href = checkoutUrl;
    } catch (error) {
      console.error('Failed to redirect to checkout:', error);
      throw error;
    }
  }

  async redirectToCustomerPortal(token: string): Promise<void> {
    try {
      const portalUrl = await this.createCustomerPortalSession(token);
      if (debugEnabled) dlog('StripeService: Received portal URL', portalUrl);
      // Validate the portal URL to avoid accidental redirects to the app root
      const isValidUrl = typeof portalUrl === 'string' && portalUrl.length > 0;
      const isStripePortal = isValidUrl && /stripe\.com|billing_portal|billing/.test(portalUrl);
      const isDevProfileRedirect = isValidUrl && /\/profile\?portal=/.test(portalUrl);

      if (!isValidUrl || (!isStripePortal && !isDevProfileRedirect)) {
        console.error('Unexpected portal URL:', portalUrl);
        throw new Error('Subscription portal is unavailable. Please try again later.');
      }

      window.location.href = portalUrl;
    } catch (error) {
      console.error('Failed to redirect to customer portal:', error);
      throw error;
    }
  }
}

export const stripeService = new StripeService();
